export default "__VITE_ASSET__DCERnQQ9__"